import { useState } from "react";
import guidedTourBg from "../../../assets/images/guided-tour-bg.svg";
import guidedTourimg from "../../../assets/images/guided-tour-img.svg";
// import guidedTourAnimation from "../../../assets/videos/guided-tour-animation.mp4";
import vid1 from "../../../assets/videos/vid1.webm";

function GuidedTour() {
  // Array containing the tour data
  const tourData = [
    {
      title: "GOVERNMENT TOUR",
      description:
        "Visit the KSA government booths and explore the Kingdom’s impressive advancements.",
    },
    {
      title: "TECH TOUR",
      description:
        "A journey through the latest innovations redefining technology and industry.",
    },
    {
      title: "AI TOUR",
      description:
        "Experience the forefront of artificial intelligence at DeepFest, where ideas meet impact.",
    },
    {
      title: "INVESTOR TOUR",
      description:
        "Uncover promising ventures and investment insights fueling tomorrow’s economy.",
    },
  ];
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  return (
    <div
      className="leap-w-full leap-flex leap-flex-col leap-gap-10 leap-rounded-2xl leap-shadow-2xl"
      style={{
        backgroundImage: `url(${guidedTourBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <h2 className="leap-mt-64 lg:leap-mt-40  leap-text-center leap-text-white leap-font-semibold md:leap-text-3xl leap-text-2xl">
        LEAP THROUGH A NEW LENS
      </h2>

      <div className="leap-w-[90%] leap-mx-auto leap-grid leap-grid-cols-1 2xl:leap-grid-cols-2 xl:leap-grid-cols-7 leap-gap-4">
        <div className="!leap-my-auto leap-col-span-1 2xl:leap-col-span-1 xl:leap-col-span-3 leap-p-4 leap-relative">
          {/* Image Container */}
          <div className="leap-relative leap-w-full leap-flex leap-justify-center">
            <img
              src={guidedTourimg}
              alt="guided Tour image"
              className="leap-w-[75%] leap-h-auto leap-object-cover leap-z-10"
              onLoad={() => setIsImageLoaded(true)} // Update state on image load
            />

            {/* Video Overlay */}
            {isImageLoaded && (
              <div className="leap-absolute leap-w-[48%] leap-aspect-[5/8.9] leap-top-[7%] leap-left-[27.5%]">
                <video
                  className="leap-w-full leap-h-full leap-border leap-border-solid leap-border-[linear-gradient(180deg,_#EB3DF7_0%,_#3B29AB_50%,_#73FAFD_100%)]"
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={{
                    transform: "scaleX(1.2)",
                    border: "2px solid transparent",
                    borderImage:
                      "linear-gradient(180deg, #EB3DF7 0%, #3B29AB 50%, #73FAFD 100%)",
                    borderImageSlice: 1,
                  }}
                  loading="lazy"
                >
                  <source src={vid1} type="video/mp4" />
                </video>
              </div>
            )}
          </div>
        </div>

        <div className="leap-col-span-1 2xl:leap-col-span-1 xl:leap-col-span-4 leap-flex leap-flex-col leap-gap-14 leap-p-4">
          <div className="leap-w-full">
            <span className="leap-text-white leap-uppercase leap-text-xl md:leap-text-2xl leap-font-extralight">
              take part in our guided tours and gain firsthand experience
            </span>
          </div>

          <div className="leap-grid leap-grid-cols-1 lg:leap-grid-cols-2 leap-gap-10 ">
            {tourData?.map((tour, index) => (
              <div
                key={index}
                className="leap-px-5 leap-min-h-44 leap-flex leap-flex-col leap-justify-center leap-gap-2"
                style={{
                  // clipPath:
                  //   "polygon(0 0, calc(100% - 50px) 0, 100% 50px, 100% 100%, 0 100%)",
                  border: "2px solid transparent",
                  borderImage:
                    "linear-gradient(180deg, #EB3DF7 0%, #3B29AB 50%, #73FAFD 100%)",
                  borderImageSlice: 1,
                  // backgroundColor:
                  //   "linear-gradient(180deg, #EB3DF7 0%, #3B29AB 50%, #73FAFD 100%)",
                }}
              >
                <h1 className="leap-text-[#73FAFD] leap-text-sm md:leap-text-base 2xl:leap-text-xl leap-font-bold">
                  {tour.title}
                </h1>
                <span className="leap-text-white leap-text-[12px] md:leap-text-[12px] 2xl:leap-text-[16px] leap-text-md">
                  {tour.description}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GuidedTour;
